import React, { createContext, useContext, useState, ReactNode } from 'react';

interface Activity {
    id: string;
    text: string;
    time: string;
    type: 'patient' | 'doctor' | 'appointment' | 'critical' | 'system';
    entityId?: number | string;
    navigateTo?: string;
}

interface NotificationsContextType {
    recentActivities: Activity[];
    setRecentActivities: (activities: Activity[]) => void;
}

const NotificationsContext = createContext<NotificationsContextType | undefined>(undefined);

export function NotificationsProvider({ children }: { children: ReactNode }) {
    const [recentActivities, setRecentActivities] = useState<Activity[]>([]);

    return (
        <NotificationsContext.Provider value={{ recentActivities, setRecentActivities }}>
            {children}
        </NotificationsContext.Provider>
    );
}

export function useNotifications() {
    const context = useContext(NotificationsContext);
    if (context === undefined) {
        throw new Error('useNotifications must be used within a NotificationsProvider');
    }
    return context;
}
